"use client";

import { Edit2, Megaphone, Trash2 } from "lucide-react";
import { Dialog } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { formatDate } from "@/lib/format";
import type { Aviso } from "@/types/avisos";

interface AvisoDetailSheetProps {
  aviso: Aviso;
  onClose: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  deleting?: boolean;
}

export function AvisoDetailSheet({ aviso, onClose, onEdit, onDelete, deleting }: AvisoDetailSheetProps) {
  const dateLabel = formatDate(aviso.data.substring(0, 10));
  const timeLabel = aviso.horario ? ` · ${aviso.horario.substring(0, 5)}` : "";

  return (
    <Dialog
      open
      onClose={onClose}
      title={
        <span className="flex items-center gap-2">
          <div className="flex size-6 shrink-0 items-center justify-center rounded-full bg-[#ff6b2b]/15">
            <Megaphone className="size-3.5 text-[#ff6b2b]" />
          </div>
          Aviso
          {aviso.urgente && (
            <span className="rounded-full bg-[#ff6b2b]/15 px-2 py-0.5 text-11 font-bold text-[#ff6b2b]">
              Urgente
            </span>
          )}
        </span>
      }
      footer={
        <>
          {onDelete && (
            <button
              type="button"
              onClick={onDelete}
              disabled={deleting}
              title="Excluir aviso"
              className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-destructive-dim-border bg-destructive-dim text-destructive transition-colors hover:bg-destructive/15 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <Trash2 className="size-4" />
            </button>
          )}
          {onEdit && (
            <Button variant="outline" onClick={onEdit} disabled={deleting} className="flex-1">
              <Edit2 className="size-4" />
              Editar
            </Button>
          )}
          <Button onClick={onClose} disabled={deleting} className="flex-1">Fechar</Button>
        </>
      }
    >
      <p className="mb-1 text-11 font-semibold uppercase tracking-[0.08em] text-muted-foreground/60">
        {dateLabel}{timeLabel}
      </p>
      <h2 className="mb-4 text-lg font-bold leading-snug text-foreground">{aviso.titulo}</h2>

      {aviso.mensagem && (
        <p className="leading-relaxed text-base text-muted-foreground">{aviso.mensagem}</p>
      )}
    </Dialog>
  );
}
